import React, { useState } from 'react';
import { MediumTitle, Toggle, palettes, useFlashMessage } from '@indigo-ag/component-module';
import styled from 'styled-components';

import i18next from 'core/i18n';
import { text } from 'shared';
import { DecisionModal, DecisionModalProps } from '../DecisionModal/DecisionModal';

const BlueMediumTitle = styled(MediumTitle)`
  color: ${palettes.brand.blue.base};
`;

interface ToggleOnHoldProps {
  isOnHold: boolean;
  visible: boolean;
  onConfirmation: DecisionModalProps['onConfirmAction'];
}

export const ToggleOnHold: React.FunctionComponent<ToggleOnHoldProps> = ({ isOnHold, visible, onConfirmation }) => {
  /**
   * State
   */
  const [isDecisionOpen, setIsDecisionOpen] = useState(false);

  const { addFlashMessage } = useFlashMessage();

  if (!visible) {
    return null;
  }

  const toggleOnHoldCreditAnalysis = (decisionNotes: string) => {
    const successMessage = text.firstLetterUppercase(
      isOnHold ? i18next.t('successfullyResumed') : i18next.t('successfullyPutOnHold')
    );

    return onConfirmation(decisionNotes)
      .then(() => {
        addFlashMessage({
          content: '',
          title: successMessage,
          variant: 'success'
        });
      })
      .catch(() => {
        addFlashMessage({
          content: i18next.t('error'),
          title: '',
          variant: 'error'
        });
      });
  };

  return (
    <div className="flex align-items-center mr-3">
      <Toggle checked={isOnHold} onChange={() => setIsDecisionOpen(true)} />
      <BlueMediumTitle className="ml-2 text-transform-capitalize">{i18next.t('onHold')}</BlueMediumTitle>
      <DecisionModal
        title={!isOnHold ? i18next.t('onHold') : i18next.t('resume')}
        onConfirmAction={toggleOnHoldCreditAnalysis}
        open={isDecisionOpen}
        closeModal={() => setIsDecisionOpen(false)}
        notesRequired
      />
    </div>
  );
};
